<template>
  <div>
    <v-layout column class="mt-0 ml-4">
      <header-elements icon='mdi-power-plug-off' @showUpload="showUpload=!showUpload" title='Non-Electrical'></header-elements>
      <elements-table :items="all_non_electricals" :showUpload="showUpload" @showUpload="showUpload=!showUpload" :title="title"></elements-table>

        <v-card class="px-5 pt-0 elevation-1" v-if="showUpload">
          <!-- <v-container grid-list-xs fluid> -->
            <v-card-title class="px-0">
              <span class="subbheadline xs12">Add new {{title}} </span>
              <v-spacer></v-spacer>
              <v-btn class="pr-0 mr-0"  small @click="showUpload=!showUpload"><v-icon small>close</v-icon> CANCEL</v-btn>
            </v-card-title>
            <v-layout row wrap>
              <v-flex class="xs12">
                <v-text-field v-model="non_electrical.brand" label="Brand"></v-text-field>
              </v-flex>
              <v-flex xs12 mx-0>
                <v-radio-group row v-model="non_electrical.origin" label="Origin">
                  <v-radio v-for="vs in constants.ORIGINS" :key="vs.id" :value="vs.id" :label="vs.title" class="ml-3"></v-radio>
                </v-radio-group>
              </v-flex>
              
              <!-- <EditFieldComp v-for="field in fields" v-show="(field.category ? (non_electrical.category===field.category) : true)" :id="field.name" :name="field.name"
                :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red' : '')" :artwork="artwork" 
                :field="field" 
                :key="field.key"
                :non_electrical="non_electrical"
              >
              </EditFieldComp> -->
            </v-layout>
          <!-- </v-container> -->
          <v-flex class="xs12 ml-3 mb-3">
            <v-btn @click="save_non_electrical">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex>
        </v-card>
        <!-- <v-flex xs12 sm12 md12  v-if="all_non_electricals && all_non_electricals.length>0">
          <v-list class="xs12">
            <v-list-tile v-for="e in all_non_electricals" :key="e.id">
              <v-list-tile-title>Origin: {{origin_title(e.origin)}}</v-list-tile-title>
              <v-list-tile-title>Brand: {{e.brand}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_non_electrical" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_non_electrical" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
        </v-flex> -->
          <!-- <v-btn icon class="mt-0 mb-0 xs12"  @click="this.showUpload=!this.showUpload"><v-icon>add</v-icon></v-btn>
          <v-flex v-if="this.showUpload">
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-text-field v-model="non_electrical.title" name="title" label="Title" class="flex xs12"></v-text-field>
                <v-text-field v-model="non_electrical.duration_min" mask="time-with-seconds" hint="HH:MM:SS" class="flex xs6" name="duration_min" label="Duration minutes"></v-text-field>
                <v-text-field v-model="non_electrical.duration_timecode" mask="##:##:##:##" hint="HH:MM:SS:FR" class="flex xs6" name="duration_timecode" label="Duration Timecode"></v-text-field>
              </v-layout>
            </v-container>
            <v-btn @click="add">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex> -->
        
    </v-layout>
  </div>
</template>

<script>
  import HeaderElements from './HeaderElements'
  import ElementsTable from './ElementsTable'
  export default {
    props: ['artwork','field'],
    data: () => ({
      title: 'Non-Electric Device',
      non_electricals: [
        { id:1, title: ' 1', bulb_origin: 1, bulb_specification: 'test specs'},
        { id:3, title: ' 2', bulb_origin: 1, bulb_specification: 'test specs'},
        { id:2, title: ' 3', bulb_origin: 1, bulb_specification: 'test specs'},
      ],
      categories: ['monitor','projector','motor', 'bulb', 'switch'],
      fields: [
        {
          'ctype': 'radio',
          // 'selection': [{id: 1, title: 'Unique'}, {id: 2, title: 'Dedicated'}, {id: 3, title: 'Historic Dedicated'}, {id: 4, title: 'Non-dedicated'}],
          // selection: ['Unique','Dedicated','Historic Dedicated','Non-dedicated'],
          selection: [{id: 1, name: 'Unique'}, {id: 2, name: 'Dedicated'}, {id: 3, name: 'Historic Dedicated'}, {id: 4, name: 'Non-dedicated'}],
          // selection: [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
          name: 'origin',
          title: 'Origin',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        // {
        //   name: 'switch',
        //   title: 'Switch, Counter - Specification',
        //   ctype: 'text-long',
        //   category: 'switch',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'other',
        //   title: 'Other - Specification',
        //   ctype: 'text-long',
        //   category: 'other',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        {
          name: 'brand',
          title: 'Brand',
          ctype: 'text-short',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_rights: ['admin', 'manager']
        },
      ],
      showUpload: false,
      show: false,
      showme: false,
      non_electrical: {
        title: '',
        associated_items: '',
        brand: '',
        origin: ''
      }
    }),
    computed: {
      all_non_electricals () {
        return this.$store.state.non_electricals
        // console.log(todos)
        // return todos
      },      // c () {
      // c () {
      //   return this.showme
      // }
    },
    methods: {
      origin_title (id) {
        // console.log(id)
        if (id>0 && id<5) {
          // console.log(id)
          // console.log(constants.ORIGINS)
          // console.log(constants.ORIGINS.find(o => o.id == id).title)
          return constants.ORIGINS.find(o => o.id == id).title
        }
      },
      // show_field (f) {
      //   if (f.condition) {
      //     this.showme = true
      //     var a = f.condition
      //     // console.log(a)
      //     return eval(a)
      //   } else {
      //     return true
      //   }
        // return Function('"use strict";return (a)')()
      // },
      download () {},
      // add () {
      //   this.non_electricals.push(this.non_electrical)
      //   this.showUpload=!this.showUpload
      // },
      delete_non_electrical () {},
      done_non_electrical () {},
      save_non_electrical () {
        this.non_electrical.artwork_id = this.artwork.id
        this.non_electrical.done = false
        this.non_electrical.id = this.findMinMax(this.all_non_electricals)+1
        this.$store.commit('ADD_NON_ELECTRICAL', this.non_electrical)
        // this.all_non_electricals.push(this.non_electrical)
        this.showUpload=!this.showUpload
        this.non_electrical = {
          description: '',
          title: '',
          deadline: '',
          done: false
        }
        // var anon_electrical = Object.keys(this.non_electrical).forEach(k => this.non_electrical[k]='')
        // console.log(anon_electrical)
      },
      findMinMax(arr) {
        if (arr===undefined || arr.length===0) {
          return 1
        } else {
          let max = arr[0].id
          for (let i = 1, len=arr.length; i < len; i++) {
            let v = arr[i].id
            max = (v > max) ? v : max
          }
          // console.log(max)
          return max
        }
      }
    },
    components: { HeaderElements,ElementsTable }
  }
</script>

<style scoped>
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/NonElectrical.vue